import { Scale, X } from 'lucide-react';
import { Button } from './ui/button';
import type { Card } from '../lib/types';

interface ComparisonBarProps {
  cards: Card[];
  onCompare: () => void;
  onClear: () => void;
}

export function ComparisonBar({ cards, onCompare, onClear }: ComparisonBarProps) {
  if (cards.length === 0) return null;

  return (
    <div className="absolute bottom-0 left-0 right-0 z-10 animate-slide-up">
      <div className="mx-4 mb-4 flex items-center justify-between rounded-2xl border border-outline bg-card/95 px-4 py-3 shadow-lg backdrop-blur-sm">
        <div className="flex items-center gap-3">
          <Scale className="h-5 w-5 text-primary" />
          <span className="text-sm font-medium text-card-foreground">
            {cards.length} card{cards.length !== 1 ? 's' : ''} selected
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button onClick={onCompare} disabled={cards.length < 2} size="sm">
            Compare
          </Button>
          <button
            onClick={onClear}
            className="rounded-full p-2 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
            title="Clear selection"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
